module.exports = __webpack_public_path__ + "static/media/004_selectbrands@2x.5ba19907.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/004_selectbrands@2x.png
// module id = 566
// module chunks = 0